__webpack_require__.p = "/account-setup-svg-as-component-template/referrals-hub/";